function toStringArray(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.filter(item => typeof item === 'string');
}
function parseEmailPayload(data) {
  if (typeof data.subject !== 'string' || typeof data.htmlBody !== 'string') {
    return undefined;
  }
  const replyType = data.emailReplyType;
  return Object.assign({
    kind: 'EMAIL',
    to: toStringArray(data.to),
    cc: toStringArray(data.cc),
    bcc: toStringArray(data.bcc),
    subject: data.subject,
    htmlBody: data.htmlBody
  }, typeof data.from === 'string' && {
    from: data.from
  }, typeof data.crmObjectTypeId === 'string' && {
    crmObjectTypeId: data.crmObjectTypeId
  }, typeof data.crmObjectId === 'string' && {
    crmObjectId: data.crmObjectId
  }, typeof data.replyEngagementId === 'number' && {
    replyEngagementId: data.replyEngagementId
  }, (replyType === 'REPLY' || replyType === 'REPLY_ALL' || replyType === 'FORWARD') && {
    emailReplyType: replyType
  });
}
function parseFormsConditionalLogicPayload(data) {
  return {
    kind: 'FORMS_CONDITIONAL_LOGIC',
    formId: String(data.formId)
  };
}
function parseContentPreviewPayload(kind, data) {
  if (typeof data.previewUrl !== 'string' || typeof data.contentId !== 'number') {
    return undefined;
  }
  return Object.assign({
    kind,
    previewUrl: data.previewUrl,
    contentId: data.contentId
  }, typeof data.revisionId === 'string' && {
    revisionId: data.revisionId
  });
}
function parseDataModelPayload(data) {
  if (typeof data.dataModelContent !== 'string') return undefined;
  return {
    kind: 'DATA_MODEL',
    dataModelContent: data.dataModelContent
  };
}
function parseReportPayload(data) {
  if (typeof data.reportEggJson !== 'string') return undefined;
  return {
    kind: 'REPORT',
    reportEggJson: data.reportEggJson
  };
}
export function parseArtifactPayload(raw) {
  if (typeof raw !== 'object' || raw === null) return undefined;
  const data = raw;
  switch (data.kind) {
    case 'EMAIL':
      return parseEmailPayload(data);
    case 'FORMS_CONDITIONAL_LOGIC':
      return parseFormsConditionalLogicPayload(data);
    case 'LANDING_PAGE':
    case 'BLOG_POST':
    case 'SITE_PAGE':
      return parseContentPreviewPayload(data.kind, data);
    case 'DATA_MODEL':
      return parseDataModelPayload(data);
    case 'REPORT':
      return parseReportPayload(data);
    default:
      return undefined;
  }
}